module.exports = __webpack_public_path__ + "0c9aad84db374e56c17a15a692a78d60.svg";